// Step questions
export const STEP_QUESTIONS = [
  "In addition to what you've already told us, is there any additional background that you want us to be aware of? The more information you provide, the more accurate our matchmaking will be.",
  "What is the urgency of your request? Are you looking for immediate assistance or planning for the future?",
  "What matters most to you in your search? Think about things like urgency, budget, or location for example?"
] as const;

